import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export function NoEntries(): React.JSX.Element {
  return (
    <Box sx={{ textAlign: "center", p: "20px" }}>
      <Typography
        style={{ fontFamily: "SigmaSans" }}
        variant="h6"
        color="textSecondary"
      >
        No Entries Found
      </Typography>
    </Box>
  );
}
